/**
 * `@kitup/brand-mylore/storefront` — MyLore's landing and pricing pages.
 *
 * A web-only entry point, like `/legal`: the pages are JSX and import pictures,
 * and the API imports the brand's root. Only `apps/web-mylore` imports this.
 *
 * The package manifest points this entry at the source, not at `dist`, on
 * purpose: `tsc` cannot emit the CSS and picture imports, so the app's bundler
 * compiles it. `tsconfig.build.json` leaves it out of the build for that reason.
 */
import { brandName, type Storefront } from '@kitup/brand';
import { brand } from './brand.js';
import { legal } from './legal.js';
import { LandingPage, PricingPage } from './storefront/pages.js';
import './storefront/storefront.css';

/** The pages' copy, for tests that hold it to what it was before it moved here. */
export { storefrontCopy } from './storefront/copy.js';

export const storefront: Storefront = {
  landing: (page) => <LandingPage brand={brand} legal={legal} page={page} />,
  pricing: (page) => <PricingPage brand={brand} legal={legal} page={page} />,
  // MyLore's mark is its name, set as its own header sets it; the app's screens showed the
  // same name in the same weight before the mark became the brand's to draw.
  logo: ({ size, locale }) => (
    <span className={size === 'md' ? 'text-lg font-semibold' : 'font-semibold'}>
      {brandName(brand, locale)}
    </span>
  ),
};
